import React from 'react';
import CustomMedia from 'util/custom-media-query';
import FormDialogrenderer from './FormDialogRenderer';
import i18n from 'i18n';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import Button from 'components/common/Button';
import PaymentType from 'constants/payment-type';
import RadioField from 'components/OrderAggregators/components/RadioField';
import Credit from 'components/OrderAggregators/Payment/components/Credit';
import Bank from 'components/OrderAggregators/Payment/components/Bank';
import multipaymentManager from 'util/multipayment';
import MultiPaymentResultCodes from 'constants/multi-payment-result-codes';
import moment from 'moment';


const DialogBody = ({ form }) => (
  <div className="payment">
    <RadioField
      name="payment.type"
      labels={[
        i18n.t('orderAggregators:payment:payment.card.select'),
        i18n.t('orderAggregators:payment:payment.bank.select')
      ]}
      values={[PaymentType.card, PaymentType.bank]}
    />
    {!!+form.getState().values.payment.type ? (
      <Bank change={form.change} />
    ) : (
      <Credit change={form.change} />
    )}
  </div>
);

class PaymentDialog extends React.Component {
  handleClickSubmitButton = (form, handleSubmit) => {
    const { getState } = form;
    const { payment } = getState().values;
    const {
      showAlert,
      closeAlert,
      form: { change }
    } = this.props;
    closeAlert();

    if (payment.type === PaymentType.bank) {
      handleSubmit();
      return change('payment', {
        type: payment.type,
        payerName: payment.payerName
      });
    }

    const tokenRequestParams = {
      cardno: payment.cardno,
      holdername: payment.holdername.toUpperCase(),
      securitycode: payment.securitycode,
      expire: moment([payment.expiresYear, payment.expiresMonth - 1]).format(
        i18n.t('common:dateFormat.creditCardExpires')
      )
    };

    const savedData = this.savedData
    const savePayment = async function (savedData) {
      multipaymentManager.init();
      multipaymentManager.getToken(tokenRequestParams, res => {
        const resultCode = String(res.resultCode);
        if (resultCode === MultiPaymentResultCodes.success) {
          handleSubmit();
          change('payment', {
            type: payment.type,
            creditToken: res.tokenObject.token,
            maskedCardNo: res.tokenObject.maskedCardNo
          });
        } else {
          const code = MultiPaymentResultCodes.errorCodes.includes(resultCode)
            ? resultCode
            : 'others';
          showAlert(
            i18n.t(`orderAggregators:payment:multiPaymentErrorMessages.${code}`)
          );
        }
      });
    }

    try {
      // aerosmith.initはダイアログが開くタイミングで実行されているのでここでは何もしない
      window.aerosmith.checkScore(function() {
        savePayment(savedData)
      }, function(reason) {
        // 失敗した際はダイアログを閉じるのみなので何もしない
        if (reason === 'timeout') {
          console.log('[AerosmithService] this.object.checkScore -> filed -> ' + reason);
        } else if (reason === 'failed') {
          console.log('[AerosmithService] this.object.checkScore -> filed -> ' + reason);
        }
      });
    } catch (ex) {
      savePayment(savedData)
    }
  };

  render() {
    const { className, dialogRef, form, closeAlert } = this.props;
    const formValues = form.getState().values;

    return (
      <div className={className}>
        <FormDialogrenderer
          title={i18n.t('orderAggregators:common:order.paymentEditDialogTitle')}
          innerRef={dialogRef}
          renderBody={({ form }) => <DialogBody form={form} />}
          renderFooter={({ form, hasValidationErrors, handleSubmit }) => (
            <div className="footer-btn-wrapper">
              <Button
                buttonType="B"
                type="button"
                onClick={() => this.handleClickSubmitButton(form, handleSubmit)}
                disabled={hasValidationErrors}
              >
                {i18n.t('common:save')}
              </Button>
            </div>
          )}
          initialValues={formValues}
          onClose={() => closeAlert()}
          showCloseAlert={true}
        />
      </div>
    );
  }
}

const commonStyle = css`
  .footer-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .payment {
    padding: 40px 32px 32px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .payment {
    padding: 0;
    margin: 32px 0;

    ${RadioField} {
      margin: 16px;
    }
  }
`;

export default applyStyles(PaymentDialog)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/PaymentDialog.js